/* eslint-disable react/prefer-stateless-function */
import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import UserBlackListByCustomers from 'components/UserBlackList/UserBlackListTable/UserBlackListByCustomers';
import UserBlackListByExecutors from 'components/UserBlackList/UserBlackListTable/UserBlackListByExecutors';
import { t } from 'utils/translates';

class MyUsersBlackList extends Component {
  render() {
    return (
      <React.Fragment>
        <div
          className="panel panel-default panel-heading_padding-large"
          id="statMyAffiliates"
        >
          <div className="panel-heading text-center">
            <h2 className="panel-title">
              <i className="fa fa-users fa-lg" />{' '}
              {t('Черный список исполнителей')}
            </h2>
          </div>
          <div className="panel-body">
            <UserBlackListByExecutors {...this.props} />
          </div>
        </div>
        <div
          className="panel panel-default panel-heading_padding-large"
          id="statMyAffiliates"
        >
          <div className="panel-heading text-center">
            <h2 className="panel-title">
              <i className="fa fa-users fa-lg" />{' '}
              {t('Черный список заказчиков')}
            </h2>
          </div>
          <div className="panel-body">
            <UserBlackListByCustomers {...this.props} />
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default withRouter(MyUsersBlackList);



// WEBPACK FOOTER //
// ./src/lauoyts/LayoutApp/Content/Users/MyUsersBlackList/MyUsersBlackList.js